import React from 'react';

import { MarketplaceSaleChannelType } from '@anyx/common-graphql';

const AmazonAddPage = React.lazy(() =>
  import('./pages/add').then((module) => ({ default: module.AmazonAddPage }))
);

const AmazonEditPage = React.lazy(() =>
  import('./pages/edit').then((module) => ({ default: module.AmazonEditPage }))
);

const AmazonTemplate = React.lazy(() =>
  import('./templates').then((module) => ({ default: module.AmazonTemplate }))
);

export const amazonRouting = [
  {
    path: MarketplaceSaleChannelType.AmazonSellerCentral,
    element: <AmazonTemplate />,
    children: [
      {
        index: true,
        element: <AmazonAddPage />,
      },
      {
        path: ':channelId',
        children: [
          {
            index: true,
            element: <AmazonEditPage />,
          },
        ],
      },
    ],
  },
];
